import { render } from "./AlzataRoleList.vue?vue&type=template&id=af10685e"
import script from "./AlzataRoleList.vue?vue&type=script&lang=js"
export * from "./AlzataRoleList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__